import React from 'react';
import styled from 'styled-components';
import { DisplayQueryColumn } from '@monorepo/shared/componentsV2/QueryResultsTable/resultsMapper';
import { TruncatedColumnLabel } from './TruncatedColumnLabel';
import { ViewColumnShowHideButton } from './ViewColumnShowHideButton';

const StyledReorderableColumnListItem = styled.div`
  display: flex;
  padding: 0.125rem 0;
  margin-left: 2rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.gray666};
  white-space: pre-wrap;
  -webkit-text-stroke: 0.5px transparent;

  /* stylelint-disable no-descending-specificity */
  & .MuiButtonBase-root {
    opacity: 0;
    transition: opacity 0.1s ease-in-out;
  }

  &:focus-within .MuiButtonBase-root,
  &:hover .MuiButtonBase-root {
    opacity: 1;
  }
  /* stylelint-enable no-descending-specificity */
`;

export function ReorderableColumnListItem({
  column,
  disableShowHideButton,
  toggleColumnVisibility,
}: {
  column: DisplayQueryColumn;
  disableShowHideButton: boolean;
  toggleColumnVisibility: (column: DisplayQueryColumn) => void;
}) {
  return (
    <StyledReorderableColumnListItem>
      <TruncatedColumnLabel column={column} tooltipOffset={26} showIcon>
        <ViewColumnShowHideButton
          column={column}
          disabled={disableShowHideButton}
          onClick={() => {
            toggleColumnVisibility(column);
          }}
        />
      </TruncatedColumnLabel>
    </StyledReorderableColumnListItem>
  );
}
